import { Typography } from '@mui/material';
import React from 'react';

import usePageHeaderStyles from '../PageHeader/styles';
import { HeaderProps } from './types';

/** Presentation component for PageHeader */
const Header: React.FunctionComponent<HeaderProps> = (props) => {
  const classes = usePageHeaderStyles(props);
  const { subtitle, title, addonsLeft, addonsRight, addonsTop, customTitle } = props;

  const renderHeader = () => {
    return (
      <header className={classes.wrapper}>
        {addonsTop}
        <section className={classes.titleWrapper}>
          {!!addonsLeft && (
            <Typography className={classes.leftSideAddons} variant='h1' component='span'>
              {addonsLeft}
            </Typography>
          )}

          {customTitle || (
            <Typography variant='h1' className={classes.heading} fontSize={'1.4em'}>
              {title}
            </Typography>
          )}

          {!!addonsRight && (
            <Typography className={classes.addons} variant='h1' component='span'>
              {addonsRight}
            </Typography>
          )}
        </section>

        {!!subtitle && <Typography className={classes.subtitle}>{subtitle}</Typography>}
      </header>
    );
  };

  return renderHeader();
};

export default Header;
